"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEmail = void 0;

// Quick validation https://stackoverflow.com/a/32686261
var isValidEmail = function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

exports.isValidEmail = isValidEmail;